"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sdk = void 0;
var fs_1 = __importDefault(require("fs"));
var universal_url_1 = require("universal-url");
var form_data_1 = __importDefault(require("form-data"));
var mime_1 = __importDefault(require("mime"));
var axios_1 = __importDefault(require("axios"));
var js_crypto_1 = require("@stratumn/js-crypto");
var core_1 = require("@apollo/client/core");
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var helpers_1 = require("./helpers");
var Sdk = /** @class */ (function () {
    function Sdk(endpoint) {
        var _this = this;
        /**
         * Configures authorization and sends a request.
         */
        this.request = function (config, useToken) {
            if (useToken === void 0) { useToken = true; }
            if (useToken && !!_this.token) {
                config.headers = __assign(__assign({}, config.headers), { authorization: "Bearer ".concat(_this.token) });
                return axios_1.default.request(config);
            }
            return axios_1.default.request(__assign(__assign({}, config), { withCredentials: true }));
        };
        this.post = function (path, data, headers, onProgress) { return __awaiter(_this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                config = {
                    data: data,
                    headers: headers,
                    url: "".concat(this.endpoint).concat(path),
                    method: 'POST',
                };
                if (onProgress) {
                    config.onUploadProgress = function (_a) {
                        var loaded = _a.loaded, total = _a.total;
                        onProgress({
                            uploadBytes: loaded,
                            uploadPercent: Math.round((loaded * 100) / total),
                            totalPercent: 50 + Math.round((loaded * 50) / total),
                        });
                    };
                }
                return [2 /*return*/, this.request(config)];
            });
        }); };
        this.setToken = function (token) {
            _this.token = token;
            return _this;
        };
        this.setTraceApiUrl = function (traceApiUrl) {
            _this.traceApiUrl = traceApiUrl;
            _this.setUpApolloClient();
            return _this;
        };
        this.setUpApolloClient = function () {
            var httpLink = new core_1.HttpLink({ uri: "".concat(_this.traceApiUrl, "/graphql"), fetch: cross_fetch_1.default });
            var authMiddleware = new core_1.ApolloLink(function (operation, forward) {
                operation.setContext({
                    headers: {
                        Authorization: "Bearer ".concat(_this.token),
                    },
                });
                return forward(operation);
            });
            _this.client = new core_1.ApolloClient({
                link: authMiddleware.concat(httpLink),
                cache: new core_1.InMemoryCache(),
                defaultOptions: {
                    watchQuery: {
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'all',
                    },
                    query: {
                        fetchPolicy: 'no-cache',
                        errorPolicy: 'all',
                    },
                },
                headers: {}
            });
        };
        /**
         * Uploads multiple files to media-api.
         * Unless explicitly disabled, files will be encrypted before the upload.
         * @param files in NodeJS: the files paths. In a browser: an array of File
         * objects.
         * @param opts upload configuration options.
         * @param opts.onProgress callback to keep track of the upload.
         * @param opts.disableEncryption set to true to disable encryption.
         * @param opts.key encryption key (base64-encoded). If not provided, one will
         * be generated.
         * @returns information about the uploaded files.
         */
        this.uploadFiles = function (files, opts) { return __awaiter(_this, void 0, void 0, function () {
            var formData, disableEncryption, encryptionKey, filesInfo, headers, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new form_data_1.default();
                        disableEncryption = opts && opts.disableEncryption;
                        encryptionKey = opts && opts.key
                            ? new js_crypto_1.aes.SymmetricKey(opts.key)
                            : new js_crypto_1.aes.SymmetricKey();
                        filesInfo = [];
                        return [4 /*yield*/, Promise.all(files.map(function (file) { return __awaiter(_this, void 0, void 0, function () {
                                var info, type, filename, encryptedFile;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // handle file info
                                            if (typeof file === 'string') {
                                                info = fs_1.default.statSync(file);
                                                type = mime_1.default.getType(file) || 'Unknown';
                                                filesInfo.push({ mimetype: type, size: info.size });
                                            }
                                            else {
                                                filesInfo.push({ mimetype: file.type, size: file.size });
                                            }
                                            filename = typeof file === 'string'
                                                ? file.split(/[\\/]/).pop() || file
                                                : file.name;
                                            if (!disableEncryption) return [3 /*break*/, 1];
                                            if (typeof file === 'string') {
                                                formData.append(filename, fs_1.default.createReadStream(file), { filename: filename });
                                            }
                                            else {
                                                formData.append(filename, file, { filename: filename });
                                            }
                                            return [3 /*break*/, 3];
                                        case 1: return [4 /*yield*/, (0, helpers_1.encryptFile)(file, encryptionKey)];
                                        case 2:
                                            encryptedFile = _a.sent();
                                            formData.append(filename, encryptedFile, { filename: filename });
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        if (!process.browser) {
                            headers = formData.getHeaders();
                        }
                        return [4 /*yield*/, this.post('/files', formData, headers, opts ? opts.onProgress : undefined)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (r, idx) {
                                var info = filesInfo[idx];
                                if (disableEncryption) {
                                    return __assign(__assign({}, r), info);
                                }
                                return __assign(__assign(__assign({}, r), info), { key: encryptionKey.export().key });
                            })];
                }
            });
        }); };
        /**
         * Uploads a file to media-api.
         * Unless explicitly disabled, the file will be encrypted before the upload.
         * @param file in NodeJS: the file path. In a browser: a File object.
         * @param opts upload configuration options.
         * @param opts.onProgress callback to keep track of the upload.
         * @param opts.disableEncryption set to true to disable encryption.
         * @param opts.key encryption key (base64-encoded). If not provided, one will
         * be generated.
         * @returns information about the uploaded file.
         */
        this.uploadFile = function (file, opts) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadFiles([file], opts)];
                    case 1:
                        data = (_a.sent())[0];
                        return [2 /*return*/, data];
                }
            });
        }); };
        /**
         * Build a download URL for a file given its digest.
         * Note that this will trigger an HTTP redirect, so the download URL can only
         * be used in proper html tags (<a>, <img>, etc).
         * @param digest the file digest.
         * @returns the download url.
         */
        this.buildDownloadURL = function (digest) {
            return new universal_url_1.URL("/files/".concat(digest), _this.endpoint).href;
        };
        /**
         * Get a direct download URL for a file given its digest.
         * Note that the file might be encrypted.
         * @param digest the file digest.
         * @returns the download url and file metadata.
         */
        this.getDirectDownloadInfo = function (digest) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request({
                            validateStatus: function (status) { return status >= 200 && status < 400; },
                            url: new universal_url_1.URL("/files/".concat(digest, "/info"), this.endpoint).href,
                            method: 'GET',
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        /**
         * Get a list of file info objects matching a list of digests.
         * Note files may be encrypted.
         * @param digests array of digests to files you want.
         * @param downloadUrl whether or not to populate the download_url field.
         * @returns the download url and file metadata.
         */
        this.getFileInfoByDigests = function (digests, downloadUrl) {
            if (downloadUrl === void 0) { downloadUrl = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var downloadOption, queryPath, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            downloadOption = downloadUrl ? "&download_url=".concat(true) : '';
                            queryPath = "/files/info?digests=".concat(digests.join(',')).concat(downloadOption);
                            return [4 /*yield*/, this.request({
                                    validateStatus: function (status) { return status >= 200 && status < 400; },
                                    url: new universal_url_1.URL(queryPath, this.endpoint).href,
                                    method: 'GET',
                                })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        /**
         * Download a file given its digest.
         * If a decryption key is provided, the file will be decrypted.
         * @param digest the file digest.
         * @param onProgress (optional) handler to report periodic download progress.
         * @param key (optional) decryption key (base64-encoded).
         * @returns the file (decrypted if key was provided).
         */
        this.downloadFile = function (digest, onProgress, key) { return __awaiter(_this, void 0, void 0, function () {
            var _a, download_url, name, useToken, data, downloadedData, decryptionKey;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getDirectDownloadInfo(digest)];
                    case 1:
                        _a = _b.sent(), download_url = _a.download_url, name = _a.name;
                        useToken = false;
                        return [4 /*yield*/, this.request({
                                validateStatus: function (status) { return status >= 200 && status < 400; },
                                url: download_url,
                                method: 'GET',
                                onDownloadProgress: onProgress,
                                // If the file isn't encrypted, we need to tell axios to treat it as a
                                // file blob.
                                // If its a browser always use blob.
                                responseType: process.browser ? 'blob' : 'arraybuffer',
                            }, useToken)];
                    case 2:
                        data = (_b.sent()).data;
                        downloadedData = data;
                        if (!key) return [3 /*break*/, 4];
                        decryptionKey = new js_crypto_1.aes.SymmetricKey(key);
                        return [4 /*yield*/, (0, helpers_1.decryptFile)(data, decryptionKey)];
                    case 3:
                        downloadedData = _b.sent();
                        _b.label = 4;
                    case 4:
                        if (process.browser) {
                            try {
                                return [2 /*return*/, new File([downloadedData], name)];
                            }
                            catch (_) {
                                // MS Edge does not implement File
                                return [2 /*return*/, Object.assign(new Blob([downloadedData]), {
                                        name: name,
                                    })];
                            }
                        }
                        return [2 /*return*/, downloadedData];
                }
            });
        }); };
        /**
         * Decrypt and return a file given its digest and traceId.
         * @param attachment An Attachment object.
         * @returns A DecryptedFile object.
         */
        this.downloadFileFromTrace = function (attachment) { return __awaiter(_this, void 0, void 0, function () {
            var digest, traceId, result, traceStateData, fileInState, decryptedFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        digest = attachment.digest, traceId = attachment.traceId;
                        if (!this.client) {
                            throw new Error('Trace API url not set');
                        }
                        return [4 /*yield*/, this.client.query({
                                query: (0, core_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query GetTraceState($id: UUID!) {\n            traceById(id: $id) {\n                state {\n                    data\n                }\n            }\n        }\n      "], ["\n        query GetTraceState($id: UUID!) {\n            traceById(id: $id) {\n                state {\n                    data\n                }\n            }\n        }\n      "]))),
                                variables: {
                                    id: traceId,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.errors) {
                            throw new Error("Error while fetching trace : ".concat(result.errors[0].message));
                        }
                        traceStateData = result.data.traceById.state.data;
                        try {
                            fileInState = (0, helpers_1.findFileInState)(traceStateData, digest);
                        }
                        catch (error) {
                            throw new Error("Error while finding file in state : ".concat(error));
                        }
                        return [4 /*yield*/, this.downloadFile(fileInState.digest, undefined, fileInState.key)];
                    case 2:
                        decryptedFile = _a.sent();
                        return [2 /*return*/, {
                                name: fileInState.name,
                                size: fileInState.size,
                                mimetype: fileInState.mimetype,
                                decryptedContent: decryptedFile
                            }];
                }
            });
        }); };
        this.endpoint = endpoint;
    }
    return Sdk;
}());
exports.Sdk = Sdk;
var templateObject_1;
//# sourceMappingURL=sdk.js.map